import {
    ListarMotivoInadimplenciaService,
    GetMotivoInadimplenciaService,
    InserirMotivoInadimplenciaService,
    AtualizarMotivoInadimplenciaService,
    DeletarMotivoInadimplenciaService,
} from "../../../Services/Cobranca/MotivoInadimplencia/MotivoInadimplenciaService";

import { IMotivoInadimplencia } from "../../../Interfaces/Cobranca/MotivoInadimplencia/MotivoInadimplenciaInterface";
import { Controller } from "../../Controller";

export async function ListarMotivoInadimplenciaController() {
    return Controller(ListarMotivoInadimplenciaService());
}

export async function GetMotivoInadimplenciaController(
    IDMotivoInadimplencia: number
) {
    return Controller(GetMotivoInadimplenciaService(IDMotivoInadimplencia));
}

export async function InserirMotivoInadimplenciaController(
    requestBody: IMotivoInadimplencia
) {
    return Controller(InserirMotivoInadimplenciaService(requestBody));
}

export async function AtualizarMotivoInadimplenciaController(
    requestBody: IMotivoInadimplencia
) {
    return Controller(AtualizarMotivoInadimplenciaService(requestBody));
}

export async function DeletarMotivoInadimplenciaController(
    IDMotivoInadimplencia: number
) {
    return Controller(DeletarMotivoInadimplenciaService(IDMotivoInadimplencia));
}
